define('views/pages/trade/request/table-row',['require','jquery','underscore','views/base/view','models/pages/trade/request/processed/index','views/pages/trade/request/processed/index','helpers/application','text!templates/pages/trade/request/table-row.ejs','views/dialog'],function(require) {
    'use strict';

    var $ = require('jquery'),
        _ = require('underscore'),
        View = require('views/base/view'),
        ProcessedModalModel = require('models/pages/trade/request/processed/index'),
        ProcessedModalView = require('views/pages/trade/request/processed/index'),
        applicationHelper = require('helpers/application'),
        templateTableRow = require('text!templates/pages/trade/request/table-row.ejs'),
        Dialog = require('views/dialog');

    /*
        TRADE REQUEST TABLE ROW
    */

    var TradeRequestRowView = View.extend({
        template: templateTableRow,
        // className: 'trade-table-row',
        tagName: 'tr',
        listen: {
            'change model': 'render'
        },

        clickRow: function() {
            var item = this.model.collection.findWhere({ selected: true });
            if (item && item !== this.model) {
                item.set('selected', false);
            }
            this.model.set('selected', true);
        },

        clickProcessed: function() {
            var model = new ProcessedModalModel({ requestId: this.model.get('id') });
            var view = new ProcessedModalView({ model: model });
            this.subview('modal', view);

            model.load();
        },

        render: function() {
            this.destroyTooltip();

            View.prototype.render.apply(this, arguments);

            // this.$el.addClass('trade-table-status-' + applicationHelper.requestStateCode(this.model.get('state')));

            if (this.model.get('selected')) {
                this.$el.addClass('active');
            } else {
                this.$el.removeClass('active');
            }
            this.bindEvents();

            this.$('.tc-request-r-comment i').tooltip({ container: 'body', placement: 'bottom' });

            // this.$el.attr('request-id', this.model.get('requestId'));
            // this.$el.attr('request-index', this.model.get('index'));
        },

        bindEvents: function() {
            this.$el.off('click').on('click', _.bind(this.clickRow, this));

            this.$('.tc-request-r-action .btn').off('click').on('click', _.bind(this.deleteClick, this));
        },

        deleteClick: function() {
            var _this = this;

            function handleError(model, xhr) {
                console.log('delete request error', model, xhr);

                if (xhr.responseJSON && xhr.responseJSON.status === 'denied') {
                    Dialog
                        .show(
                            'Удаление заказа',
                            'Не удалось удалить позицию из заказа. Удаление заблокировано.',
                            Dialog.Buttons.Close
                        );
                } else {
                    Dialog
                        .show(
                            'Удаление заказа',
                            'Не удалось удалить позицию из заказа.',
                            Dialog.Buttons.Close
                        );
                }
            }

            Dialog
                .show('Удаление позиции заказа', 'Вы действительно хотите удалить выбранную позицию из заказа?', Dialog.Buttons.YesNo)
                .attach(this)
                .submit(function() {
                    console.log('delete request', _this.model);
                    _this.model.destroy({
                        wait: true,
                        dataType: 'text',
                        error: handleError,
                        success: function() {
                            console.log('delete request success', arguments);
                        }
                    });
                });
        },

        dispose: function() {
            if (this.disposed) { return; }

            this.destroyTooltip();

            View.prototype.dispose.apply(this, arguments);
        },

        destroyTooltip: function() {
            this.$('.tc-request-r-comment i').tooltip('destroy');
        }
    });


    return TradeRequestRowView;
});

